import classNames from 'classnames';
import { Plus } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { clearSelectedChampionship } from 'modules/tournaments/store/championship/actions';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

type Props = {
  className?: string;
};

const MainComponentsEmptyListMessage = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCreateTourneyClick = useCallback(() => {
    dispatch(clearSelectedChampionship());
    navigate(Pages.TOURNEYS.CREATE);
  }, [dispatch, navigate]);

  return (
    <div className={classNames('d-flex flex-column align-items-center', props.className)}>
      <UDText type="headline" className="mb-2">
        {t('championships.emptyList.title')}
      </UDText>
      <UDText type="body-text" className="mb-6">
        {t('championships.emptyList.body')}
      </UDText>
      <UDButton variant="dark" className="d-flex align-items-center flex-row" onClick={handleCreateTourneyClick}>
        {/* <UDColorableIcon
         name="plus"
         componentProps={{ className: 'mr-2 color-AccentNapplesYellow' }}
         /> */}
        <Plus size={16} className="color-AccentNapplesYellow mr-2" />
        {t('championships.createTournamentButtonTitle')}
      </UDButton>
    </div>
  );
};

export default MainComponentsEmptyListMessage;
